import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { XIcon } from '@heroicons/react/outline';

/**
 * CompleteAdminHandoverDialog
 * ---------------------------
 * The admin team's "Mark handover complete" confirmation on the Admin
 * Handover screen (TDI-391, TDI-686). Confirming records who finished the
 * handover and when, and moves the child out of Admin Handover to Accepted or
 * Not accepted. There is no undo on the screen, so the dialog says where the
 * child goes and asks admin to finish the EMIS work first.
 *
 * On a combined referral the handover is per pathway, so the sentence names
 * the pathway being completed (pathwayName); otherwise it names the child.
 */
export default function CompleteAdminHandoverDialog({
  open,
  onOpenChange,
  firstName,
  destination,
  pathwayName = null,
  completing = false,
  onConfirm,
}) {
  const subject = pathwayName ? `${firstName}’s ${pathwayName} referral` : firstName;
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="radix-dialog-overlay-motion fixed inset-0 bg-black/40 backdrop-blur-sm z-50" />
        <Dialog.Content className="radix-dialog-content-centered-motion fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90vw] max-w-md bg-white rounded-xl shadow-lg z-50 overflow-hidden">
          <div className="flex items-start justify-between p-5 pb-3">
            <div className="text-left">
              <Dialog.Title className="text-base font-semibold text-gray-900">
                Mark the handover complete?
              </Dialog.Title>
              <Dialog.Description className="text-sm text-gray-700 mt-2">
                {subject} will move from Admin Handover to {destination}.
              </Dialog.Description>
              <p className="text-sm text-gray-500 mt-2">
                Do this once the letter and documents are on EMIS. You can’t undo it here.
              </p>
            </div>
            <Dialog.Close asChild>
              <button
                type="button"
                className="p-1 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
                aria-label="Close"
              >
                <XIcon className="w-5 h-5" />
              </button>
            </Dialog.Close>
          </div>

          <div className="flex justify-end gap-2 p-5 pt-3">
            <Dialog.Close asChild>
              <button
                type="button"
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm font-medium"
              >
                Cancel
              </button>
            </Dialog.Close>
            <button
              type="button"
              disabled={completing}
              onClick={() => onConfirm && onConfirm()}
              className="px-5 py-2 bg-primary text-white text-sm font-medium rounded-lg hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Mark handover complete
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
